import React from 'react';
import type { VehicleDialogOrigin } from './actions';
import PropertyDialog from './Property';
import VehicleDialog from './Vehicles';

const AssetDialog = (props: {
  assetType: 'realEstate' | 'vehicle';
  linkTo?: string;
  onBackToSource?: () => void;
  dialogOrigin?: VehicleDialogOrigin;
}) => {
  const { assetType, linkTo, onBackToSource, dialogOrigin } = props;
  if (assetType === 'realEstate') {
    return <PropertyDialog linkTo={linkTo} />;
  }
  if (assetType === 'vehicle') {
    return <VehicleDialog linkTo={linkTo} onBackToSource={onBackToSource} dialogOrigin={dialogOrigin} />;
  }
  return null;
};

export default AssetDialog;
